<template>
  <!-- Exemple avec Font Awesome 6 -->
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css" crossorigin="anonymous" referrerpolicy="no-referrer" />
  <div>
    <!-- Affichage conditionnel de la navbar si l'utilisateur est connecté ET email vérifié -->
    <ShowcaseNavbar v-if="isShowcaseRoute" />
    <NavMenu v-if="isAuthenticated && isEmailVerified && !isShowcaseRoute && !isAuthRoute" />
    <div id="appBody">
      <router-view />
    </div>
    <Footer v-if="isShowcaseRoute" />
  </div>
</template>

<script>
import { reactive, provide, computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import NavMenu from './components/Navbars/NavMenu.vue'
import ShowcaseNavbar from './components/Navbars/ShowcaseNavbar.vue';
import Footer from './components/Navbars/Footer.vue';
import { getCurrentUser, getUserById } from "@/services/userService";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { fetchProjects } from "@/services/projectService";
import { fetchClients } from "@/services/clientService";
import { fetchRessources } from "@/services/ressourceService";
import { fetchEvents } from "@/services/eventService";
import { fetchIdeas } from "@/services/ideaService";
import { fetchUserParameters } from "@/services/parameterService";
import { fetchPayments } from "@/services/paymentService";
import { fetchUsers } from "@/services/userService";

export default {
  components: {
    NavMenu,
    ShowcaseNavbar,
    Footer
  },
  setup() {
    const route = useRoute();
    // Utilise ref pour les booléens
    const isAuthenticated = ref(false);
    const isEmailVerified = ref(false);

    // reactive pour les tableaux/objets
    const state = reactive({
      userPermissions: {},
      currentUser: null,

      projects: [],
      clients: [],
      ressources: [],
      events: [],
      ideas: [],
      parameters: {},
      payments: [],
      users: []
    });

    provide('projects', state.projects);
    provide('clients', state.clients);
    provide('ressources', state.ressources);
    provide('events', state.events);
    provide('ideas', state.ideas);
    provide('parameters', () => state.parameters);
    provide('payments', state.payments);
    provide('users', state.users);

    provide('userPerm', () => {
      const mapped = {};
      for (const key in state.userPermissions) {
        mapped[key] = state.userPermissions[key]?.permission || "none";
      }
      return mapped;
    });
    provide('currentUser', () => state.currentUser);

    const isShowcaseRoute = computed(() =>
      (route.name && route.name.toLowerCase().startsWith('showcase')) ||
      route.path === '/'
    );
    const isAuthRoute = computed(() =>
      route.path === '/login' || route.path === '/register'
    );

    // Auth listener
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      isAuthenticated.value = !!user;
      isEmailVerified.value = false;

      if (user) {
        const userData = await getUserById(user.uid);
        let permissions = userData.permissions || {};

        if (userData.mainUserId) {
          try {
            const mainUserData = await getUserById(userData.mainUserId);
            const mainPerms = mainUserData.permissions || {};
            for (const key in mainPerms) {
              permissions["main" + key.charAt(0).toUpperCase() + key.slice(1)] = mainPerms[key];
            }
          } catch (e) {
            console.warn("Impossible de charger les permissions du main user :", e);
          }
        } else {
          for (const key in permissions) {
            permissions["main" + key.charAt(0).toUpperCase() + key.slice(1)] = permissions[key];
          }
        }

        state.userPermissions = permissions;

        // Email vérifié
        if (userData.requiresEmailVerification === false) {
          isEmailVerified.value = true;
        } else {
          isEmailVerified.value = !!user.emailVerified;
        }

        // Chargement des données globales après connexion
        state.projects.splice(0, state.projects.length, ...(await fetchProjects()));
        state.clients.splice(0, state.clients.length, ...(await fetchClients()));
        state.ressources.splice(0, state.ressources.length, ...(await fetchRessources()));
        state.events.splice(0, state.events.length, ...(await fetchEvents()));
        state.ideas.splice(0, state.ideas.length, ...(await fetchIdeas()));
        state.parameters = await fetchUserParameters();
        state.payments.splice(0, state.payments.length, ...(await fetchPayments()));
        state.users.splice(0, state.users.length, ...(await fetchUsers()));
      } else {
        state.userPermissions = {};
        state.projects.splice(0);
        state.clients.splice(0);
        state.ressources.splice(0);
        state.events.splice(0);
        state.ideas.splice(0);
        state.parameters = {};
        state.payments.splice(0);
        state.users.splice(0);
      }
    });

    // Chargement de l'utilisateur courant
    getCurrentUser().then(async (authUser) => {
      if (authUser) {
        const user = await getUserById(authUser.uid);
        state.currentUser = user;
      }
    });

    return {
      ...state,
      isAuthenticated,
      isEmailVerified,
      isShowcaseRoute,
      isAuthRoute
    };
  }
}
</script>

<style>
*{
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

#appBody {
  text-align: center;
  margin: 0%;
}

body{
  margin:0%;
  background-color: #FCFCFC;
} 


.basicDiv{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  background-color: #ebebeb;
  border: 1px solid #dadada;
  padding: 4px 8px;
  border-radius: 8px;
}

.basicInput{
  height: 36px;              /* h-9 */
  border-radius: 12px;       /* rounded-xl */
  padding: 8px;              /* p-2 */
  border-style: solid;       /* !border-solid (avec !important si nécessaire) */
  border-width: 1px;         /* !border-[1px] (avec !important si nécessaire) */
  border-color: #D1D5DB;      /* border-gray-300 */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
}

.basicContainer{
  border-radius: 12px;       /* rounded-xl */
  padding: 12px;              /* p-2 */
  border-style: solid;       /* !border-solid (avec !important si nécessaire) */
  border-width: 1px;         /* !border-[1px] (avec !important si nécessaire) */
  border-color: #D1D5DB;      /* border-gray-300 */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
}

input::placeholder {
  color: #bebebe; /* Exemple : gris moyen (Tailwind: placeholder-gray-500) */
}

*,
*::before,
*::after {
  box-sizing: border-box;
}
</style>